import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-background-100 overflow-hidden">
      <div className="absolute -left-20 top-10 w-64 h-80 bg-background-200/50 rounded-3xl rotate-12 hidden lg:block"></div>
      <div className="absolute -right-16 bottom-8 w-56 h-72 bg-background-200/50 rounded-3xl -rotate-12 hidden lg:block"></div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="bg-background-50 rounded-3xl px-6 md:px-10 py-12 md:py-16 my-10 md:my-14">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
            <div className="lg:col-span-2">
              <Link to="/" className="inline-block mb-4">
                <span className="font-heading text-2xl font-bold text-primary-500">
                  韩漫网站
                </span>
              </Link>
              <p className="text-foreground-600 text-sm leading-relaxed max-w-sm">
                韩漫免费在线观看平台，提供海量韩国漫画大全，支持下拉式流畅阅读体验。每日更新热门连载，涵盖热血、恋爱、奇幻、武侠、都市等多种类型，是韩漫爱好者的最佳阅读选择。
              </p>
              <div className="flex items-center gap-3 mt-6">
                <a href="#" className="w-9 h-9 rounded-full bg-background-100 flex items-center justify-center text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full bg-background-100 flex items-center justify-center text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full bg-background-100 flex items-center justify-center text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="B站">
                  <i className="ri-bilibili-line text-lg"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-5">快速导航</h4>
              <ul className="flex flex-col gap-3">
                <li><Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">首页</Link></li>
                <li><Link to="/category/all" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">热门连载</Link></li>
                <li><Link to="/category/all" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">最新上架</Link></li>
                <li><Link to="/category/all" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">排行榜</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-5">分类浏览</h4>
              <ul className="flex flex-col gap-3">
                <li><Link to="/category/all" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">热血少年</Link></li>
                <li><Link to="/category/all" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">恋爱甜宠</Link></li>
                <li><Link to="/category/all" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">奇幻冒险</Link></li>
                <li><Link to="/category/all" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">武侠江湖</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-5">关于我们</h4>
              <ul className="flex flex-col gap-3">
                <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">品牌介绍</Link></li>
                <li><a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">用户协议</a></li>
                <li><a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">隐私政策</a></li>
                <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">联系我们</Link></li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-200/70">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-sm text-foreground-500">
                &copy; {currentYear} 韩漫网站. All rights reserved.
              </p>
              <div className="flex items-center gap-4 text-sm text-foreground-500">
                <a href="#" className="hover:text-primary-500 transition-colors cursor-pointer">用户协议</a>
                <span className="text-background-300">|</span>
                <a href="#" className="hover:text-primary-500 transition-colors cursor-pointer">隐私政策</a>
                <span className="text-background-300">|</span>
                <a href="#" className="hover:text-primary-500 transition-colors cursor-pointer">版权声明</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}